import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import prepareHeaders from '../utils/prepareHeaders'

export const FEEDBACK_FEATURES = { IMPACT_ASSESSMENT: 'impact_assessment' }
export const MAX_FEEDBACK_TEXT_LENGTH = 5000

export const productFeedbackApi = createApi({
  reducerPath: 'productFeedback',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    submitProductFeedback: builder.mutation({
      query: ({ organizationId, ...body }) => ({
        url: `/organization/${organizationId}/feedback`,
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const { useSubmitProductFeedbackMutation } = productFeedbackApi
